import { JobAttachmentsService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { adminJobsKeys } from 'app/queries/adminJobs/adminJobsKeys';
import type { TCall } from 'app/queries/types/TCall';

type TParams = QueryFunctionContext<ReturnType<typeof adminJobsKeys.attachment>>;

export const createFetchJobAttachmentQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ jobId, attachmentId }], signal }: TParams) =>
    call(() => cancelOnSignal(JobAttachmentsService.adminGetAttachment({ jobId, attachmentId }), signal));
